// Externe Bibliotheken
import React, { Component } from 'react';
import { Link } from 'react-router';
import axios from 'axios';

// Interne Module
import partialCancellationConfig from '@/_config/partial-cancellation';
import * as storage from '@/_helper/storage';
import { withRouter } from '@/_helper/withRouter';
import { getBookingData } from '@/_helper/fetchNewData';
import { convertPrice } from '@/_helper/mapper';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import Excursion from './excursion';
import SeatReservation from './seat-reservation';
import StatusPage from '@/comp/statusPage/statusPage';

// Styles
import './overview.scss';

class PartialCancellationOverview extends Component {
    content = {
        ausflug: {
            wording: {
                headline: 'Ausflug stornieren',
                error: {
                    accept: 'Um das Formular abschicken zu können, müssen Sie beiden Bedingungen zustimmen.',
                },
                noRefundAlert:
                    'Dieser Ausflug ist nicht erstattbar. Bitte stornieren Sie ihn trotzdem, damit wir Sie von der ' +
                    'Teilnehmendenliste streichen können.',
                successpage: {
                    backLinkText: 'Zurück zu meinen Ausflügen',
                },
            },
            checkboxes: [
                {
                    checked: false,
                    text: 'Ja, ich möchte meinen Ausflug jetzt für alle Teilnehmenden stornieren.',
                },
                {
                    checked: false,
                    text: (
                        <>
                            Ich akzeptiere die{' '}
                            <a href={`${window.$website}/unternehmen/agb`} rel="noopener noreferrer" target="_blank">
                                Allgemeinen Geschäftsbedingungen
                            </a>{' '}
                            sowie die{' '}
                            <a href={`${window.$website}/unternehmen/agb`} rel="noopener noreferrer" target="_blank">
                                Zahlungs- und Stornierungsbedingungen
                            </a>{' '}
                            der AurumTours GmbH. Sollten Sie bereits Zahlungen für diesen Ausflug an uns geleistet
                            haben, wird Ihnen dieser Betrag von AurumTours mit der ursprünglich bei der Buchung
                            angegebenen Zahlungsmethode erstattet, sofern der Ausflug erstattungsfähig ist.
                        </>
                    ),
                },
            ],
        },
        sitzplatzreservierung: {
            noRefund: true,
            wording: {
                headline: 'Sitzplatzreservierung stornieren',
                error: {
                    accept: 'Um das Formular abschicken zu können, müssen Sie beiden Bedingungen zustimmen.',
                    checkedServiceDetails:
                        'Um das Formular abschicken zu können, müssen Sie einen Sitzplatz zum Stornieren auswählen.',
                },
                noRefundAlert:
                    'Sitzplatzreservierungen sind nicht erstattbar. Bitte stornieren Sie diese trotzdem, damit die Plätze wieder freigegeben werden können.',
                successpage: {
                    backLinkText: 'Zurück zu meinen <wbr/>Sitzplatzreservierungen',
                },
            },
            checkboxes: [
                {
                    checked: false,
                    text: 'Ja, ich möchte meine Sitzplatzreservierung jetzt stornieren.',
                },
                {
                    checked: false,
                    text: (
                        <>
                            Ich akzeptiere die{' '}
                            <a href={`${window.$website}/unternehmen/agb`} rel="noopener noreferrer" target="_blank">
                                Allgemeinen Geschäftsbedingungen
                            </a>{' '}
                            sowie die{' '}
                            <a href={`${window.$website}/unternehmen/agb`} rel="noopener noreferrer" target="_blank">
                                Zahlungs- und Stornierungsbedingungen
                            </a>{' '}
                            der AurumTours GmbH.
                        </>
                    ),
                },
            ],
        },
    };

    constructor(props) {
        super(props);

        this.state = {
            bookingData: storage.get('bookingData') !== null ? storage.get('bookingData') : {},
            service: this.reformatServiceTitle(props?.params?.service),
            index: parseInt(props?.params.index),
            prices: {},
            wording: this.content[props?.params?.service]?.wording,
            formValid: false,
            checkboxes: this.content[props?.params?.service]?.checkboxes,
            alreadyTested: false,
            pageState: 'initial',
            noRefund: this.content[props?.params?.service]?.noRefund,

            // ToDO : remove after Testing
            debug_notRevalidateAfterSubmitSucess: true,
            // End ToDO
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.getCheckedServiceDetailsChange = this.getCheckedServiceDetailsChange.bind(this);
    }

    reformatServiceTitle(val) {
        return val !== undefined && val.charAt(0).toUpperCase() + val.slice(1);
    }

    componentDidMount() {
        document.title = `${this.state.service ? this.state.service + ' |' : ''} Stornierung ${window.$documentTitle}`;
        document.querySelector('html').classList.add('redesign');

        if (this.state.service) {
            const redirect = this.checkPossibleRedirect(this.state.service.toLowerCase(), this.state.index);

            if (redirect !== '') {
                window.location.href = redirect;
            } else {
                this.setPrices();
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        document.querySelector('html').classList.add('redesign');

        if (prevProps.params?.index !== this.props.params?.index || prevState.service !== this.state.service) {
            this.setState(
                {
                    service: this.reformatServiceTitle(this.props.params.service),
                    index: parseInt(this.props.params.index),
                },
                () => {
                    const redirect = this.checkPossibleRedirect(this.state.service.toLowerCase(), this.state.index);

                    if (redirect !== '') {
                        window.location.href = redirect;
                    } else {
                        this.setPrices();
                    }
                }
            );
        }
    }

    checkPossibleRedirect(service, index) {
        let value = '';

        if (storage.get('cancellationData') === null) {
            value = `#/leistung-stornieren/${service}`;
        }
        if (service === undefined || partialCancellationConfig?.allowToCancellationService === undefined) {
            value = '#/';
        }
        if (!partialCancellationConfig?.allowToCancellationService.includes(service)) {
            value = '#/stornierungsoptionen';
        }

        switch (service) {
            case 'ausflug':
                const excursions = this.state.bookingData.data.frontendParams.excursions;
                const item = excursions[index];

                if (item?.state === 'XX' || index < 0 || index > excursions.length - 1) {
                    value = '#/leistung-stornieren/ausflug';
                }
                break;
            case 'sitzplatzreservierung':
                break;
            case 'transfer':
                break;
            case 'railandfly':
                break;
            default:
                return <></>;
        }
        return value;
    }

    setPrices() {
        const { frontendParams } = this.state.bookingData.data;

        let packagePrice, servicePrice, cancellationPrice, refundValue, newPackagePrice;

        packagePrice = frontendParams.price.packagePrice;

        if (this.state.service === 'Ausflug') {
            servicePrice = frontendParams.excursions[this.state.index].price;
            cancellationPrice = frontendParams.excursions[this.state.index].currentCancellationPrice;
        }
        refundValue = servicePrice - cancellationPrice;
        newPackagePrice = packagePrice - servicePrice + cancellationPrice;

        const prices = {
            packagePrice: convertPrice(packagePrice),
            cancellationPrice: convertPrice(cancellationPrice),
            refundValue: refundValue && `${refundValue > 0 ? '-' : ''} ${convertPrice(refundValue)}`,
            newPackagePrice: convertPrice(newPackagePrice),
            noRefund: refundValue <= 0,
        };

        this.setState({ prices: prices });
    }

    handleCheckboxChange(index) {
        const { checkboxes } = this.state;

        checkboxes[index].checked = !checkboxes[index].checked;

        this.setState(
            {
                checkboxes: checkboxes,
            },
            () => {
                this.validateForm();
            }
        );
    }

    getCheckedServiceDetailsChange(c) {
        // set text : successpage
        let contentStoreWording = this.state.wording;
        contentStoreWording.successpage.subline = (
            <>
                Das hat geklappt! Wir haben die Stornierung{' '}
                {this.state?.checkedServiceDetails && Object.keys(this.state.checkedServiceDetails).length > 0
                    ? 'Ihrer Sitzplätze'
                    : 'Ihres Sitzplätzes'}{' '}
                zur Buchung <b>{storage.get('bookingNumber')}</b> erhalten.
            </>
        );

        this.setState(
            {
                checkedServiceDetails: c,
                wording: contentStoreWording,
            },
            () => {
                this.validateForm();
            }
        );
    }

    validateForm() {
        const { checkedServiceDetails, checkboxes } = this.state;

        // default
        let formValidCondition = checkboxes.every((item) => item.checked === true);

        // has checked service details
        let hasCheckedServiceDetails = !!checkedServiceDetails;

        if (hasCheckedServiceDetails) {
            switch (this.state.service) {
                case 'Sitzplatzreservierung':
                    formValidCondition =
                        formValidCondition && Object.keys(checkedServiceDetails.seatReservationBookingIds).length > 0;
                    break;
                default:
            }
        }

        this.setState({
            formValid: formValidCondition,
        });
    }
    handleSubmit() {
        const bookingData = this.state.bookingData;
        const bookingNumber = storage.get('bookingNumber');

        const data = {
            bookingId: bookingNumber,
            travelType: 'package',
            clientId: 'customerarea',
        };

        if (this.state.formValid) {
            this.setState({ pageState: 'validate' });

            let { bookedSeats } = bookingData.data.serviceInformation;
            let { excursions, seatReservation } = bookingData.data.frontendParams;

            // set canceled states
            const setCanceledStates = () => {
                switch (this.state.service) {
                    case 'Ausflug':
                        excursions[this.state.index].state = 'XX';
                        break;
                    case 'Sitzplatzreservierung':
                        let { checkedServiceDetails } = this.state;
                        let cancellationData = storage.get('cancellationData');

                        if (checkedServiceDetails?.seatReservationBookingIds) {
                            let { seatReservationBookingIds } = checkedServiceDetails;

                            Object.values(seatReservationBookingIds).forEach((item, key) => {
                                if (seatReservation[item]) {
                                    // set canceled state : seatReservation
                                    seatReservation[item].state = 'XX';

                                    // set canceled state : booked seats
                                    let getRawOfferKey = item.split('-')[0];
                                    if (getRawOfferKey) {
                                        let bookedSeatsIndex = Object.values(bookedSeats)
                                            .map((e) => e.offerKey)
                                            .indexOf(getRawOfferKey);

                                        if (bookedSeats[bookedSeatsIndex]) {
                                            bookedSeats[bookedSeatsIndex].state = 'XX';
                                        }
                                    }

                                    // disable cancellation allowed : seatReservation booked seat
                                    cancellationData.seatReservation[item].cancellationAllowed = false;
                                }
                            });

                            storage.set('cancellationData', cancellationData);
                            storage.set('bookingData', bookingData);
                        }
                        break;
                    default:
                }
            };

            // set submit data
            switch (this.state.service) {
                case 'Ausflug':
                    data.serviceType = 'excursion';
                    data.supplierBookingId = excursions[this.state.index].bookingId;
                    break;
                case 'Sitzplatzreservierung':
                    let { checkedServiceDetails } = this.state;

                    console.log(checkedServiceDetails);

                    if (Object.keys(checkedServiceDetails?.seatReservationBookingIds).length > 0) {
                        let { seatReservationBookingIds } = checkedServiceDetails;

                        data.serviceType = 'seatReservation';
                        data.supplierBookingId = seatReservationBookingIds.join();
                    } else {
                        this.setState({
                            pageState: 'error',
                        });
                    }
                    break;
                default:
            }

            axios({
                url: window.$serviceUrl + '/cancelService?token=' + window.$token,
                method: 'POST',
                data: data,
            })
                .then((response) => response)
                .then((data) => {
                    if (data?.status === 200) {
                        // ToDO : remove after Testing
                        if (this.state.debug_notRevalidateAfterSubmitSucess) {
                            this.setState({
                                pageState: 'success',
                            });

                            // End ToDo
                        } else {
                            getBookingData(storage.get('access_token'))
                                .then(() => {
                                    this.setState({
                                        pageState: 'success',
                                    });
                                })
                                .catch(() => {
                                    this.setState({
                                        pageState: 'error',
                                    });
                                });
                        }
                    } else {
                        this.setState({
                            pageState: 'error',
                        });
                    }

                    setCanceledStates();
                })
                .catch(() => {
                    this.setState({
                        pageState: 'error',
                    });
                });
        } else {
            this.setState({ alreadyTested: true });
        }
    }

    render() {
        const data = this.state.bookingData.data;
        const index = this.state.index;
        let serviceComp, statusSubPage;

        switch (this.state.service) {
            case 'Ausflug':
                const item = data.frontendParams.excursions[index];
                serviceComp = item && <Excursion item={item} prices={this.state.prices} />;
                statusSubPage = 'partialCancellationExcursion';
                break;
            case 'Sitzplatzreservierung':
                let params = new URLSearchParams(this.props?.params.index);
                serviceComp = data && (
                    <SeatReservation
                        seatReservations={data?.frontendParams?.seatReservation}
                        flightDetails={data?.frontendParams?.flightDetails}
                        bookedSeats={data?.serviceInformation?.bookedSeats}
                        params={params}
                        prices={this.state.prices}
                        alreadyTested={this.state.alreadyTested}
                        getCheckedServiceDetailsChange={this.getCheckedServiceDetailsChange}
                    />
                );
                statusSubPage = 'partialCancellationSeatReservation';
                break;
            case 'Transfer':
                break;
            case 'Railandfly':
                break;
            default:
                return <></>;
        }

        return (
            <div className={`page-partial-cancellation-overview ${this.state.service.toLowerCase()}`}>
                <Header />

                {/* ToDO : remove after Testing*/}
                {process.env.VITE_ENV !== 'production' && (
                    <div
                        className="debug-bar"
                        style={{
                            background: '#e6e6e6',
                            padding: '20px',
                            display: 'flex',
                            justifyContent: 'center',
                        }}>
                        <div className="checkbox-input">
                            <input
                                type="checkbox"
                                name={`debug_notRevalidateAfterSubmitSucess`}
                                id={`debug_notRevalidateAfterSubmitSucess`}
                                onChange={() =>
                                    this.setState({
                                        debug_notRevalidateAfterSubmitSucess:
                                            !this.state.debug_notRevalidateAfterSubmitSucess,
                                    })
                                }
                                checked={this.state.debug_notRevalidateAfterSubmitSucess}
                            />
                            <span
                                className="icon"
                                onClick={() =>
                                    this.setState({
                                        debug_notRevalidateAfterSubmitSucess:
                                            !this.state.debug_notRevalidateAfterSubmitSucess,
                                    })
                                }></span>

                            <label htmlFor={`debug_notRevalidateAfterSubmitSucess`}>Fake-Logik</label>
                        </div>
                    </div>
                )}

                {/* End ToDO*/}

                {this.state.pageState === 'error' ? (
                    <StatusPage type="error" subPage={statusSubPage} />
                ) : this.state.pageState === 'success' ? (
                    <StatusPage
                        type="success"
                        subPage={statusSubPage}
                        subline={this.state?.wording?.successpage?.subline}
                        backLink={`/#/leistung-stornieren/${this.state.service.toLowerCase()}`}
                        backLinkText={this.state?.wording?.successpage?.backLinkText}
                    />
                ) : (
                    <div className="content-wrapper slim">
                        <h1 className="main-headline">{this.state?.wording?.headline}</h1>
                        <div className={`content ${this.state.pageState}`}>
                            {serviceComp !== undefined && serviceComp}
                            {(this.state.noRefund || this.state.prices.noRefund) && (
                                <div className="cancellation-info">
                                    <i className="material-symbols-outlined">info</i>
                                    {this.state?.wording?.noRefundAlert}
                                </div>
                            )}
                            <section className="accept-sec">
                                {this.state.checkboxes &&
                                    this.state.checkboxes.map((item, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <div className="checkbox-input">
                                                    <input
                                                        type="checkbox"
                                                        name={`cancellation-accept-${index}`}
                                                        id={`cancellation-accept-${index}`}
                                                        onChange={() => this.handleCheckboxChange(index)}
                                                        checked={item.checked}
                                                    />
                                                    <span
                                                        className="icon"
                                                        onClick={() => this.handleCheckboxChange(index)}></span>

                                                    <label htmlFor={`cancellation-accept-${index}`}>{item.text}</label>
                                                </div>
                                                {index === this.state.checkboxes.length - 1 &&
                                                    this.state.alreadyTested &&
                                                    this.state.checkboxes.filter((checkbox) => checkbox.checked)
                                                        .length !== this.state.checkboxes.length && (
                                                        <div className="error">{this.state?.wording.error?.accept}</div>
                                                    )}
                                            </React.Fragment>
                                        );
                                    })}

                                {this.state.checkedServiceDetails &&
                                    this.state.alreadyTested &&
                                    Object.keys(this.state.checkedServiceDetails).length === 0 && (
                                        <div className="error">{this.state?.wording.error?.checkedServiceDetails}</div>
                                    )}
                            </section>

                            <section className="user-action">
                                <button
                                    className={`${this.state.formValid ? 'valid' : 'invalid'}${
                                        this.state.pageState === 'validate' ? ' validate' : ''
                                    }`}
                                    onClick={this.handleSubmit}>
                                    {this.state.prices.refundValue ? (
                                        <>Jetzt für {this.state.prices.refundValue} stornieren</>
                                    ) : (
                                        <>Jetzt stornieren</>
                                    )}

                                    {this.state.pageState === 'validate' && <span className="loader"></span>}
                                </button>
                                <Link
                                    to={`/leistung-stornieren/${this.state.service.toLowerCase()}`}
                                    className="button-back">
                                    <span className="material-symbols-outlined">chevron_left</span>
                                    Zurück zur Übersicht
                                </Link>
                            </section>
                        </div>
                    </div>
                )}
                <Footer />
            </div>
        );
    }
}

export default withRouter(PartialCancellationOverview);
